import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";
import { formatNumber } from "../../libraries/helper";
 
export default () => {

  const moduleName = "cart_settings";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName,  location.search));
  }, [appReducer.cart_settings_destroy,  location.search]);

  useEffect(() => {
    if (appReducer.cart_settings_list != undefined) {
      setRows(appReducer.cart_settings_list.data)
      setTotalPages(appReducer.cart_settings_list.count)
    }
  }, [appReducer])


  const columns = [

    {
      name: 'کمینه قیمت',
      selector: row => `${formatNumber(row.min_price)} تومان`  ,
    },
    {
      name: 'پیام کمینه قیمت',
      selector: row => row.min_price_message,
    },
    {
      name: 'تاریخ ایجاد',
      selector: row => row.created_at,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <Template.Table count={totalPages}   columns={columns} data={rows} />;

};
